import React, { useState, useEffect } from "react";
import { Heart, Home, Menu, X } from "lucide-react";
import { navLinks } from "../mock";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = (e) => {
    e.preventDefault();
    document.getElementById("preorder")?.scrollIntoView({ behavior: "smooth" });
    setOpen(false);
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled ? "bg-[#EAE9F6]/95 backdrop-blur shadow-sm" : "bg-[#EAE9F6]"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-8">
        {/* Logo */}
        <a href="#top" className="flex items-center gap-3">
          <div className="relative flex h-11 w-11 items-center justify-center">
            <Home className="h-10 w-10 text-[#6618D0]" strokeWidth={1.5} />
            <Heart
              className="absolute h-4 w-4 fill-[#990EE5] text-[#990EE5]"
              style={{ top: "13px" }}
            />
          </div>
          <div className="leading-none">
            <span className="font-script text-2xl text-[#6618D0]">The Motivated</span>
            <div className="font-serif-display text-base font-bold tracking-wide text-[#6618D0]">
              PARENTS <span className="font-normal">&</span> EDUCATORS
            </div>
            <div className="text-[8px] font-bold tracking-[0.15em] text-[#7a8aa0]">
              CALM PARENTING. CONFIDENT KIDS.
            </div>
          </div>
        </a>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-9 lg:flex">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="font-serif-display text-[15px] font-semibold text-[#6618D0] transition-colors hover:text-[#990EE5]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <button
          onClick={scrollToTop}
          className="hidden rounded-md bg-[#6618D0] px-6 py-3 font-serif-display text-sm font-bold tracking-wide text-white shadow-sm transition-all hover:bg-[#5512b0] hover:shadow-md active:scale-[0.98] md:block"
        >
          PREORDER NOW
        </button>

        {/* Mobile toggle */}
        <button
          className="text-[#6618D0] lg:hidden"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="border-t border-[#D8CFF0] bg-[#EAE9F6] px-5 py-4 lg:hidden">
          <nav className="flex flex-col gap-4">
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-serif-display text-base font-semibold text-[#6618D0]"
              >
                {l.label}
              </a>
            ))}
            <button
              onClick={scrollToTop}
              className="mt-2 rounded-md bg-[#6618D0] px-6 py-3 font-serif-display text-sm font-bold tracking-wide text-white"
            >
              PREORDER NOW
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}
